<template>
<div id="container" class="olympia">
    <div class="fullscreen_background">
        <img src="/static/assets/olympia/Hintergrund_2860.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <div class="libero z40">
        <img class="img" src="/static/assets/olympia/olympia_libero.png" />
    </div>
    <div class="dike z30">
        <img class="img" src="/static/assets/olympia/Kalli_Dike.png" />
    </div>
  <div class="zopyos z30">
        <!-- <img class="img" src="/static/assets/olympia/Schwimmer.png" /> -->
        <img class="img" src="/static/assets/olympia/zopyos.png" />
    </div>
  <div class="queen z30">
        <!-- <img class="img" src="/static/assets/olympia/Schwimmer.png" /> -->
        <img class="img" src="/static/assets/olympia/olympia_feueri.png" />
    </div>
    <div class="genia z30">
        <img class="img" src="/static/assets/olympia/Iphi_Genia.png" />
    </div>
  <div class="astylos z30">
        <img class="img" src="/static/assets/olympia/Hugi_Astylos.png" />
    </div>
    <div class="hera z30">
        <img class="img" src="/static/assets/olympia/Hera_Kles.png" />
    </div>
	<div class="augia z30">
        <img class="img" src="/static/assets/olympia/Gigi_Augia.png" />
    </div>
    <div class="xippos z30">  
      <img class="img" src="/static/assets/olympia/Dubix_Xippos.png" />
    </div>
	
    <router-link to="/game" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil.png" />
    </router-link>

    <router-link to="/wal" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/alle/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/olympia/Textfeld.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Geschichte_1_Gigi_Augia.mp3" jsonurl="/static/assets/geschichten/Gigi_Augia.json" content=".olympia" target="olympia_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="olympia_target">
        <p>Die Hohe Priesterin Gigi Augia schritt die marmornen Treppen ihres Tempels herab und machte sich, von ihren Dienerinnen begleitet, auf den Weg zum olympischen Hain. Ehrfurchtsvoll verbeugten sich die Menschen auf Olympias Straßen und machten dem Gefolge der Hohen Priesterin Platz. An der olympischen Bibliothek befahl sie zu halten und schickte ihre Dienerinnen Kalli Dike und Iphi Genia, ihre Bestellung aus der Bibliothek abzuholen. Heute wurden im Stadion Olympias die Laufwettkämpfe ausgetragen und als Hohe Priesterin der Göttin Demeter musste Gigi Augia anwesend sein. Das freute sie nicht besonders, denn es langweilte sie immer ein wenig, den Athleten dabei zuzusehen, wie sie auf den Bahnen hin- und herrannten. Deshalb hatte sie mit Kalli Dike beschlossen, während der Laufpausen die wunderschönen Reime der Sappho zu lesen, einer Dichterin, deren Zeilen so herrlich wie Musik klangen! Kalli Dike begann ihr im Stadion gerade vorzulesen, als die Läufer durch die Tore schritten und das Publikum ihnen laut zujubelte. Unter ihnen waren die größten Sportstars ihrer Zeit: Alexis Zopyros aus Rhodos, Dubix Xippos aus Sparta, Hugi Astylos aus Athen und Hera Kles aus Theben. Ihre Muskeln strotzten vor Tatendrang und ihre Herzen pochten laut vor Aufregung. Sie winkten ihren Fans zu, die ihre Stars feierten, über die gegnerischen Läufer aber lachten sie laut: „Zeig dem durchtrainierten Spartaner, wer den Marathon erfunden hat“, „Der soll lieber Eulen zurück nach Athen tragen, statt hier anzutreten!“, „Der Koloss von Rhodos sieht aber stärker aus!“! Die Hohe Priesterin Gigi Augia erhob sich und blickte streng in die Runde.</p>
<p>Augenblicklich verstummten die gemeinen Rufe. „Noch so ein Wort und ich puste das olympische Feuer aus und lasse euch aus dem Stadion werfen!“, rief sie empört. „Empfangt ihr so unsere Gäste? Ist das euer berühmter Sportsgeist?“ Die Fans blickten bedröppelt auf die griechischen Zehen, die aus ihren Ledersandalen ragten, und schüttelten eifrig ihre Köpfe. Gigi Augia setzte sich. Dieses unfaire Verhalten beim Sport mochte sie einfach nicht, da las sie lieber. „Lies mir noch was von Sappho vor“, bat sie ihre Dienerin Kalli Dike. „Aber jetzt geht es los, Herrin. Wir sollten uns den Lauf ansehen — die Höflichkeit verlangt es.“ „Natürlich, du hast Recht!“ Gigi Augia gähnte und blickte nach unten auf die Rennbahn. Der Start klappte, in nur wenigen Sekunden setzten sich die Favoriten Alexis Zopyros, Dubix Xippos und Hugi Astylos an die Spitze der Läufer. Als verfolgten sie eine Furie, sausten sie fast gleichauf am Publikum vorbei, das vor Begeisterung tobte. Da geschah es: Kurz vor dem Ziel überquerte der kleine weiße Hund Libero Teles die Laufbahn und brachte Alexis Zopyros zu Fall. Und was taten Dubix Xippos und Hugi Astylos? Sie stoppten ihren schnellen Lauf und halfen Alexis Zopyros aufzustehen, stützten ihn und brachten ihn rasch an den Laufbahnrand! Jetzt gelangten die anderen Läufer ins Ziel und der Thebaner Hera Kles feierte sich als Sieger. Was war geschehen? Gigi Augias jüngste Dienerin Iphi Genia hatte ihr Hündchen Libero Teles zuhause im Tempel gelassen. Doch das treue Kerlchen war ihr gefolgt und sorgte nun für den größten Tumult, den Olympia bis dahin gesehen hatte. Wütend verlangte das Publikum, man solle Dubix Xippos oder Hugi Astylos zum Sieger küren.</p>
<p>Gigi Augia verlangte nach dem Wettkampfrichter Pausa Nias und beriet sich mit ihm. Dann stand sie auf und sprach zu den ihr gebannt lauschenden Fans. „Was schön ist, ist gut. Und wer gut ist, wird bald schön sein. — Das sagt unsere große Dichterin Sappho. Ich hätte nicht gedacht, dass sich ihre Worte beim Sport bewahrheiten. Doch tatsächlich, Dubix Xippos und Hugi Astylos, ihr seid gut und damit schön! Eure Fairness hat mich für den Sport begeistert. Deshalb erklären wir euch zusammen mit Alexis Zopyros zu den Siegern dieses Laufes!“ Das Stadion wogte unter allgemeiner Zustimmung und tosendem Beifall. Schnell wurden noch zwei Lorbeerkränze geflochten, das Siegerpodest um zwei Plätze erweitert und schließlich die drei Sieger gekürt. Das gefiel dem Publikum übrigens so gut, dass man seitdem im Sport immer auch einen zweiten und dritten Sieger feiert. Außerdem entschied man sich für eine weitere Neuerung: Die Steintafeln im Stadion sollten nicht mehr für honigtriefende Süßigkeiten werben. Fortan trugen sie den Slogan:</p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'olympia',
  data () {
    return {
      who: 'olympia'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Archivseite_Gigi_Titel_Augia.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Gigi_Augia_Atmo2.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* olympia */
.olympia { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.olympia .himmel { display: block !important; }

.olympia .geschichte { position: absolute; top: 170px; left:52%;  }

.olympia .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.olympia .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

  .olympia .gigi {position: absolute; left: 528px; bottom: 343px;}
  .olympia .libero_dino {position: absolute; left: 458px; bottom: 243px; animation: dubix_erscheint 1s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
.olympia .gigi {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}

 .augia.z30 {
    position: absolute;
    bottom: 95px;
    left: 430px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}
.zopyos.z30 {
    position: absolute;
    top: -270px;
    left: -484px;
}    
.genia.z30 {
    position: absolute;
    left: 250px;
    bottom: 120px;
    animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}
.xippos.z30 {
    position: absolute;
    bottom: 264px;
    left: 570px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}  
.astylos.z30 {
    position: absolute;
    top: 713px;
    left: 870px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}
.hera.z30 {
    position: absolute;
    top: 510px;
    left: 640px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.7s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}
.dike.z30 {
    position: absolute;
    top: 435px;
    left: 370px;
animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.6s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}  
.libero.z40 {
    position: absolute;
    top: -297px;
    left: -500px;
}    
    @keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.olympia .queen.z30 {
    position: absolute;
    top: -271px;
    left: -481px;
    /* animation: queen_erscheint 5s ease-out; animation-delay: 1s; animation-fill-mode: forwards;*/
}  
.olympia .schild { position: absolute; bottom: 29px; left: 209px; }
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  25% {
    -ms-transform: translate(20px,30px);
    -moz-transform: translate(20px,30px);
    -webkit-transform: translate(20px,30px);
    -o-transform: translate(20px,30px);
    transform: translate(20px,30px);
  }
  50% {
    -ms-transform: translate(-10px,10px);
    -moz-transform: translate(-10px,10px);
    -webkit-transform: translate(-10px,10px);
    -o-transform: translate(-10px,10px);
    transform: translate(-10px,10px);
  }
  75% {
    -ms-transform: translate(-20px,-20px); 
    -moz-transform: translate(-20px,-20px); 
    -webkit-transform: translate(-20px,-20px);
    -o-transform: translate(-20px,-20px);
    transform: translate(-20px,-20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.olympia .hovering1 {
  -webkit-animation: hovering 18s linear infinite;
  -moz-animation: hovering 18s linear infinite;
  -ms-animation: hovering 18s linear infinite;
  -o-animation: hovering 18s linear infinite;
  animation: hovering 18s linear infinite;
}
.olympia .hovering2 {
  -webkit-animation: hovering 22s linear infinite;
  -moz-animation: hovering 22s linear infinite;
  -ms-animation: hovering 22s linear infinite;
  -o-animation: hovering 22s linear infinite;
  animation: hovering 22s linear infinite;
}
.olympia .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}
.olympia .hovering4 {
  -webkit-animation: hovering 24s linear infinite;
  -moz-animation: hovering 24s linear infinite;
  -ms-animation: hovering 24s linear infinite;
  -o-animation: hovering 24s linear infinite;
  animation: hovering 24s linear infinite;
}
/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,10px);
    -moz-transform: translate(20px,10px);
    -webkit-transform: translate(20px,10px);
    -o-transform: translate(20px,10px);
    transform: translate(20px,10px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.olympia .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}
.blubber.blubber_animation {
    top: -25%;
    left: -25%;
    position: absolute;
}
.olympia .john {
    position: absolute;
    top: 248px;
    left: 787px;
  animation: dubix_erscheint 1s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;
}
.olympia .drohne {
    position: absolute;
    top: -320px;
    left: -580px;
}

@keyframes blubber_animation {
    100% { background-position: 0 -9720px; }
}
.olympia .wassergeist {position: absolute; top: 871px; left: 10px;}
.wassergeist_animation {
  width: 122px;
  height: 204px;
  background: url('/static/assets/olympia/Wassergeist_Animation.png') top center;
  animation-delay: 1s;
  animation: wassergeist_animation 15s steps(15) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes wassergeist_animation {
    0% { background-position: 0 -0px; }
    10% { background-position: 0 -3060px; }
    100% { background-position: 0 -3060px; }
}	
span { font-family: FrozenMemory; } 
.player {
    position: absolute;
    top: 660px !important;
    left: 110px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Olympia.vue